<template>
  <!-- CONTACT FORM START-->
  <section class="section scroll-select" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">Somos Carentes</h1>
          <div class="section-title-border margin-t-20"></div>
          <p
            class="section-subtitle text-muted text-center font-secondary padding-t-30"
          >
            Gostamos sempre de estar em contato com nossos clientes. Entendemos
            que a comunicação é essencial para construir relacionamentos fortes
            e duradouros.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div class="mt-4 pt-4">
            <p class="mt-4">
              <span class="h5">Grande São Paulo:</span><br />
              <span class="text-muted d-block mt-2"
                >Avenida Bruno Galantinni nº 1265, cj4 4º andar</span
              >
            </p>
            <p class="mt-4">
              <span class="h5">Ribeirão Preto:</span><br />
              <span class="text-muted d-block mt-2"
                >Rua Germano Chiffre nº 43990, 15º andar <br />São Paulo -
                SP</span
              >
            </p>
            <p class="mt-4">
              <span class="h5">Horário de funcionamento:</span><br />
              <span class="text-muted d-block mt-2"
                >Da primeira chícara de café até as 18:00HS</span
              >
            </p>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="custom-form mt-4 pt-4">
            <div id="message"></div>
            <form
              method="post"
              action="php/contact.php"
              name="contact-form"
              id="contact-form"
            >
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <input
                      name="name"
                      id="name"
                      type="text"
                      class="form-control"
                      placeholder="Nome...*"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <input
                      name="email"
                      id="email"
                      type="email"
                      class="form-control"
                      placeholder="Email...*"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group mt-2">
                    <input
                      type="text"
                      class="form-control"
                      id="subject"
                      placeholder="Assunto..."
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group mt-2">
                    <textarea
                      name="comments"
                      id="comments"
                      rows="4"
                      class="form-control"
                      placeholder="Mensagem..."
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 text-right">
                  <input
                    type="submit"
                    id="submit"
                    name="send"
                    class="submitBnt btn btn-custom"
                    value="Enviar"
                  />
                  <div id="simple-msg"></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- CONTACT FORM END-->
</template>

<script>
export default {
  name: "Contact",
  props: {}
};
</script>
